export default {
  common: {
    siteName: "AllChinaBuy Spreadsheet",
    siteTagline: "Finds, Guides & Resources",
    disclaimer: "Independent resource — not affiliated with AllChinaBuy",
    nav: {
      home: "Home",
      categories: "Categories",
      guides: "Guides",
      shoppingGuide: "Shopping Guide",
      safety: "Safety",
    },
    lang: {
      label: "Language",
      en: "English",
      fr: "Français",
      da: "Dansk",
      de: "Deutsch",
    },
    buttons: {
      buyNow: "Buy It Now",
      mainCta: "AllChinaBuy Spreadsheet",
      explore: "Explore",
      visitMain: "Visit Main Website",
      readGuide: "Read Guide",
      backHome: "Back to Home",
      learnMore: "Learn more",
    },
    categories: {
      shoes: "Shoes",
      hoodies: "Hoodies/Sweaters",
      tshirts: "T-Shirts",
      jackets: "Jackets",
      pants: "Pants/Shorts",
      headwear: "Headwear",
      sets: "Sets",
      underwear: "Underwear/Underpants",
      jersey: "Jersey",
      accessories: "Accessories",
      bags: "Bags",
      belts: "Belts",
      perfumes: "Perfumes",
      other: "Other Stuff",
    },
    footer: {
      about: "AllChinaBuy Spreadsheet is an independent informational hub that helps shoppers discover organized spreadsheet resources, product finds, buying guides, shipping tips and QC information.",
      explore: "Explore",
      resources: "Resources",
      home: "Home",
      guide: "Complete Guide",
      categoriesLabel: "Categories",
      legal: "Legal",
      privacy: "Privacy",
      terms: "Terms",
      affiliate: "Affiliate Disclosure",
      copyright: "All rights reserved.",
      independent: "This site is an independent resource and is not affiliated with or endorsed by AllChinaBuy.",
    },
  },
};